import React from "react";
import dayjs from "dayjs";

const PermissionFormEdit = ({ formik, isPartner, isCreate, isDisabled = false }) => {
  return (
    <div className="p-4">
      <div className="row">
        <div className="col-md-12 mb-3">
          <label className="form-label">Descripción *</label>
          <textarea
            name="description"
            className="form-control"
            rows="4"
            placeholder="Describe el motivo del permiso..."
            value={formik.values.description}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            disabled={!isCreate || isDisabled}
          />
          {formik.touched.description && formik.errors.description && (
            <div className="text-danger">{formik.errors.description}</div>
          )}
        </div>

        <div className="col-md-6 mb-3">
          <label className="form-label">Fecha del Permiso *</label>
          <input
            type="date"
            name="startRequested"
            className="form-control"
            min={dayjs().add(1, "day").format("YYYY-MM-DD")}
            value={formik.values.startRequested}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            disabled={!isCreate || isDisabled}
          />
          {formik.touched.startRequested && formik.errors.startRequested && (
            <div className="text-danger">{formik.errors.startRequested}</div>
          )}
          <small className="form-text text-muted">
            Mínimo 1 día de antelación
          </small>
        </div>

        <div className="col-md-6 mb-3">
          <label className="form-label">Días Solicitados</label>
          <input
            type="number"
            name="daysRequested"
            className="form-control"
            value="1"
            disabled
          />
          <small className="form-text text-muted">
            Solo se puede solicitar 1 día
          </small>
        </div>
      </div>
    </div>
  );
};

export default PermissionFormEdit; 